import { render } from "./YouTubeView.vue?vue&type=template&id=5b29363c"
import script from "./YouTubeView.vue?vue&type=script&lang=js"
export * from "./YouTubeView.vue?vue&type=script&lang=js"

import exportComponent from "/OfficialWebsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__